import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild , Router} from "@angular/router";
import { Observable, of as observableOf } from 'rxjs';
import { AuthService } from '@root/modules/common/services/auth.service';
@Injectable({providedIn: 'root'})
export class InitGuard implements CanActivate, CanActivateChild {
        constructor(private router: Router){

        }

        canActivate():Observable<boolean>{
            const isLogged = this.isLogged();
            return observableOf(isLogged)
        }

        canActivateChild():Observable<boolean>{
            const isLogged = this.isLogged();
            return observableOf(isLogged)
        }

        private isLogged():boolean{
            let isLogged: boolean = AuthService.isLogged();
            if(!isLogged){
                this.router.navigate(['/login'])
            }
            return isLogged;
        }
}